import React, { Component } from "react";
import { IoDocumentsSharp } from "react-icons/io5";
// import { MdOutlineFileDownload } from "react-icons/md";
import axios from "axios";
import { GrDocumentExcel } from "react-icons/gr";
// import { MdOutlineDeleteOutline } from "react-icons/md";
import { MdOutlineFileDownload } from "react-icons/md";


class TutorAssignmentCourse extends Component {
    state = {
        course: [],
    }
    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
        if (this.props.shouldRefresh && !prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Call onRefreshDone after fetching
        }
    }


    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            // const course_id = this.props.course_id
            // const courseId = parseInt(course_id, 10);
            let headers = {}; // Initialize an empty headers object

            if (accessToken) {
                headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }

            const response = await axios.get(`https://api.geoinfoacademy.com/api/capstone/`, {
                headers: headers,
            });
            this.setState({ course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleDelete = async (docId) => {
        const accessToken = localStorage.getItem("accessToken");


        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/capstone/${docId.id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", docId.id);
                // Optionally: Refresh the document list after successful deletion
                this.fetchCourses(); // Or whatever method you use to refresh the list
                // You might also want to provide user feedback (e.g., a toast notification)
                // alert("Document deleted successfully")
            } else {
                console.error("Error deleting document:", response.status, response.data);
                // Handle error (e.g., display an error message to the user)
                alert("Error deleting document")

            }
        } catch (error) {
            console.error("Error deleting document:", error);
            // Handle network errors or other exceptions
            alert("Error deleting document")
        }
    };




    handleDownload = async (doc) => {
        const accessToken = localStorage.getItem("accessToken");
        const documentId = doc.id; // Assuming your document object has an 'id' property

        try {
            const response = await axios.get(`https://api.geoinfoacademy.com/api/download/capstone/${documentId}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }, 
                responseType: 'blob', // Important: Specify response type as blob
            });

            // Create a blob URL for the downloaded file
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // Get the content type from the response
            const url = window.URL.createObjectURL(blob);

            // Create a temporary link and trigger the download
            const link = document.createElement('a');
            link.href = url;

            // Extract filename from Content-Disposition header if available, else use the title.
            let filename = doc.title; // Default filename (if all else fails)

            const contentDisposition = response.headers['content-disposition'];

            if (contentDisposition) {
                // 1. Try to get filename from Content-Disposition header (BEST option)
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1]; // Use filename from header
                }
            } else if (doc.file_path) {
                // 2. If Content-Disposition is missing, try to guess from doc.file_path (LESS reliable)
                try {  // Add a try-catch in case doc.file_path is malformed
                    const url = new URL(doc.file_path); // Use URL object for robust parsing
                    const pathname = url.pathname;
                    const ext = pathname.substring(pathname.lastIndexOf('.') + 1); // Extract extension

                    if (ext) {
                        filename = `${doc.title}.${ext}`; // Add guessed extension to title
                    } else {
                        console.warn("Could not determine extension from doc.file_path:", doc.file_path);
                    }

                } catch (error) {
                    console.error("Error parsing doc.file_path:", doc.file_path, error);
                }
            } else {
                console.warn("Neither Content-Disposition nor doc.file_path available for filename.");
            }


            link.setAttribute('download', filename); // Set the filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };






    render() {
        // const document = this.state.course;
        // const doclist = document && document.documents && document.documents.length ? (
        //     document.documents.map((doc) => {
        //         const fileName = doc.file_path.substring(doc.file_path.lastIndexOf('/') + 1);
        //         const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1); // Extract the extension
        //         return (
        //             <li className="document" key={doc.id}>
        //                 <IoDocumentsSharp /> <span>{doc.title}</span> <span className="file-extension">{fileExtension}</span><button onClick={() => this.handleDownload(doc)} className="download"><MdOutlineFileDownload /></button>
        //             </li>
        //         );
        //     })
        // ) : (
        //     <li className="document">
        //         <GrDocumentExcel /> No Document
        //     </li>
        // );

        const documents = this.state.course; // The API response is already the array of documents
        const doclist = documents && documents.length ? (
            documents.map((doc) => {
                const fileName = doc.file.substring(doc.file.lastIndexOf('/') + 1); // Use doc.file here
                const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
                return (
                    <li className="document" key={doc.id}>
                        <IoDocumentsSharp /> <span>{doc.title}</span> <span className="file-extension">{fileExtension}</span>
                        {/* <button onClick={() => this.handleDelete(doc)} className="download"><MdOutlineDeleteOutline /></button> */}
                        <button onClick={() => this.handleDownload(doc)} className="download"><MdOutlineFileDownload /></button>
                    </li>
                );
            })
        ) : (
            <li className="document">
                <GrDocumentExcel /> No Document
            </li>
        );

        return (
            <section className="courseassignmnt">
                <h3>Assignment</h3>
                <div className="container">
                    {/* <li><IoDocumentsSharp /> <span>israel</span> <span className="file-extension">pdf</span><button onClick={() => this.handleDownload()} className="download"><MdOutlineFileDownload /></button></li> */}
                    {doclist}
                </div>
            </section>
        )
    }
}

export default TutorAssignmentCourse